import Parse from '../../parseConfig';

export function getConsultantName(user) {
  if (!user) return '';

  const fullName = `${user.get?.('firstName') || ''} ${user.get?.('lastName') || ''}`.trim();
  return fullName || user.get?.('username') || user.get?.('email') || 'Unnamed consultant';
}

export function configureSalesConsultantQuery(query) {
  query.equalTo('fraemohsAssociate', 1);
  query.notEqualTo('isMemberOfPublic', 1);
  query.limit(1000);
  query.select(['firstName', 'lastName', 'username', 'email']);
  return query;
}

/**
 * Returns Fraemohs associates who are not public members, including inactive
 * users. Deliberately no active/inactive condition is applied to this query.
 */
export async function fetchSalesConsultants() {
  const query = configureSalesConsultantQuery(new Parse.Query(Parse.User));

  const users = await query.find();

  return users
    .map((user) => ({ id: user.id, name: getConsultantName(user) }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
